import { SCHEDULER_DAILY, SCHEDULER_MONTHLY } from "../../types";

const SchedulerReportsReducer = (state = {}, action) => {
    if ([SCHEDULER_DAILY, SCHEDULER_MONTHLY].includes(action.type)) {
        return { ...state, [action.type]: action.payload };
    };
    return state;
};

export default SchedulerReportsReducer;